<template>

<app-wrapper class="pagination">

    <div class="pagination-summary" v-if="!window.is.mobile">

        <template v-if="pages > 1">{{ total }} {{ text.noun }}<template v-if="total !== 1">s</template></template>

    </div>

    <div class="pagination-pages">

        <template v-if="pages > 1">

            <router-link v-for="index in pages" :key="index" :to="{name: route + '/Pagination', params: { page: index }}" class="pagination-pages-item" :class="{'is-active': index === current}">{{ index }}</router-link>

        </template>

    </div>

    <div class="pagination-actions">

        <app-button theme="blue" :text="text.create" class="pagination-actions-item" v-on:click="$emit('create')" />

    </div>

</app-wrapper>

</template>

<script>

export default {

    props: ['text', 'total', 'current', 'pages', 'route']

}

</script>

<style scoped>

.pagination {
    display: flex;
    flex-direction: row;
    height: 40px;
}

.pagination-summary {
    font-size: 14px;
    color: var(--color-grey-dark);
    flex-shrink: 0;
    width: 160px;
    line-height: 40px;
}

.pagination-pages {
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.is-mobile .pagination-pages {
    justify-content: flex-start;
}

.pagination-pages-item {
    height: 24px;
    line-height: 23px;
    font-size: 14px;
    font-weight: 300;
    text-align: center;
    min-width: 24px;
    padding: 0px 5px;
    border-radius: 4px;
    margin: 0px 2px;
    border: 1px solid var(--color-grey-light);
    transition: all 100ms linear;
}

.is-desktop .pagination-pages-item:hover {
    border-color: var(--color-grey-highlight);
}

.pagination-pages-item.is-active,
.is-desktop .pagination-pages-item.is-active:hover {
    background-color: var(--color-blue-light);
    border-color: var(--color-blue-light);
    color: #fff;
    font-weight: 400;
}

.pagination-actions {
    flex-shrink: 0;
    width: 160px;
    display: flex;
    justify-content: flex-end;
}

.pagination-actions-item {
    margin-left: 10px;
}

</style>